import { withTheme } from '../config';
import { CheckBox } from '@rneui/base/dist/CheckBox/CheckBox';
export { CheckBox };
export default withTheme(CheckBox, 'CheckBox');
